module.exports = __webpack_public_path__ + "img/file_type_p.6f23ba8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/file_type_p.png
// module id = u3JZ
// module chunks = 12 13 14 17 26